
export function getFieldsLI(FieldTypeEnum) {
  return {
    quantidadesCalculadas: [
      {
        key: "qtde_pessoal_total",
        name: "Pessoal Total",
        icon: "mdi-account-multiple",
        color: "#37474f",
        type: FieldTypeEnum.NUMBER,
      },
      {
        key: "qtde_pessoal_superior",
        name: "Nível Superior Total",
        icon: "mdi-account-tie",
        color: "#0d47a1",
        type: FieldTypeEnum.NUMBER,
      },
      {
        key: "qtde_pessoal_pdi",
        name: "Pessoal em P,D&I",
        icon: "mdi-account-group",
        color: "#1c1c44",
        type: FieldTypeEnum.NUMBER,
      },
      {
        key: "qtde_pessoal_superior_pdi",
        name: "Nível Superior em P,D&I",
        icon: "mdi-school",
        color: "#2e7d32",
        type: FieldTypeEnum.NUMBER,
      },
      {
        key: "qtde_patentes",
        name: "Patentes Requeridas",
        icon: "mdi-certificate",
        color: "#e65100",
        type: FieldTypeEnum.NUMBER,
      },
      {
        key: "qtde_publicacoes",
        name: "Publicações no Ano Base",
        icon: "mdi-book-open-page-variant",
        color: "#6a1b9a",
        type: FieldTypeEnum.NUMBER,
      },
    ],
    faturamento: [
      {
        key: "total_empresa",
        name: "Total da empresa",
        type: FieldTypeEnum.MONEY,
        colSize: 6,
        rules: [{ rule: "required" }],
      },
      {
        key: "total_prod_incentivados",
        name: "Total dos produtos incentivados",
        type: FieldTypeEnum.MONEY,
        colSize: 6,
        rules: [],
      },
      {
        key: "total_prod_incentivados_NNCO",
        name: "Total dos produtos incentivados fabricados nas regiões Norte, Nordeste e Centro Oeste",
        type: FieldTypeEnum.MONEY,
        colSize: 12,
        rules: [{ rule: "required" }],
      },
      {
        key: "total_tecnac",
        name: "Total de produtos com reconhecimento de bem desenvolvido no País (TecNac)",
        type: FieldTypeEnum.MONEY,
        colSize: 12,
        rules: [],
      },
      {
        key: "total_micro",
        name: "Total em microcomputadores de até R$ 11.000,00 e demais partes (Art.9º)",
        type: FieldTypeEnum.MONEY,
        colSize: 12,
        rules: [{ rule: "required" }],
      },
      {
        key: "total_software",
        name: "Total em software",
        type: FieldTypeEnum.MONEY,
        colSize: 6,
        rules: [{ rule: "required" }],
      },
      {
        key: "total_servicos_TI",
        name: "Total em serviços de TI",
        type: FieldTypeEnum.MONEY,
        colSize: 6,
        rules: [{ rule: "required" }],
      },
    ],
    exportacoes: [
      {
        key: "total_exportacao",
        name: "Exportações totais da empresa",
        type: FieldTypeEnum.MONEY,
        colSize: 6,
        rules: [{ rule: "required" }],
      },
      {
        key: "total_exportacao_incentivada",
        name: "Exportações incentivadas",
        type: FieldTypeEnum.MONEY,
        colSize: 6,
        rules: [],
      },
      {
        key: "total_exportacao_software",
        name: "Exportações de software",
        type: FieldTypeEnum.MONEY,
        colSize: 6,
        rules: [{ rule: "required" }],
      },
      {
        key: "total_exportacao_servicos",
        name: "Exportações de serviços",
        type: FieldTypeEnum.MONEY,
        colSize: 6,
        rules: [{ rule: "required" }],
      },
    ],
    importacoes: [
      {
        key: "total_importacao",
        name: "Importações totais da empresa",
        type: FieldTypeEnum.MONEY,
        colSize: 12,
        rules: [{ rule: "required" }],
      },
      {
        key: "total_importacao_insumos",
        name: "Importações totais de insumos para fabricação de produtos incentivados",
        type: FieldTypeEnum.MONEY,
        colSize: 12,
        rules: [{ rule: "required" }],
      },
      {
        key: "total_importacao_produtos",
        name: "Importações de produtos acabados para revenda (bens de informática)",
        type: FieldTypeEnum.MONEY,
        colSize: 12,
        rules: [{ rule: "required" }],
      },
      {
        key: "total_importacao_software",
        name: "Importações (remessas) de software",
        type: FieldTypeEnum.MONEY,
        colSize: 6,
        rules: [{ rule: "required" }],
      },
      {
        key: "total_importacao_servicos",
        name: "Importações (remessas) de serviços",
        type: FieldTypeEnum.MONEY,
        colSize: 6,
        rules: [{ rule: "required" }],
      },
    ],
  };
}

/**
 * Campos para FIC - Lei do Bem (LB / FORMS)
 * Baseado na tabela cad_fic
 */
export function getFieldsLB(FieldTypeEnum) {
  return {
    representante: [
      {
        key: "representante_nome",
        name: "Nome do Representante",
        type: FieldTypeEnum.TEXT,
        colSize: 4,
        rules: [{ rule: "required" }],
      },
      {
        key: "representante_cpf",
        name: "CPF do Representante",
        type: FieldTypeEnum.CPF,
        colSize: 4,
        rules: [{ rule: "required" }],
      },
      {
        key: "representante_email",
        name: "E-mail do Representante",
        type: FieldTypeEnum.TEXT,
        colSize: 4,
        rules: [{ rule: "required" }, { rule: "email" }],
      },
    ],
    empresa: [
      {
        key: "empresa_organismo",
        name: "Organismo",
        type: FieldTypeEnum.TEXT,
        colSize: 6,
        rules: [{ rule: "required" }],
      },
      {
        key: "empresa_situacao",
        name: "Situação",
        type: FieldTypeEnum.TEXT,
        colSize: 6,
        rules: [{ rule: "required" }],
      },
      {
        key: "empresa_capital_controlador",
        name: "Capital Controlador",
        type: FieldTypeEnum.TEXT,
        colSize: 6,
        rules: [{ rule: "required" }],
      },
      {
        key: "empresa_relacao_grupo",
        name: "Relação com Grupo",
        type: FieldTypeEnum.TEXT,
        colSize: 6,
        rules: [{ rule: "required" }],
      },
      {
        key: "empresa_receita",
        name: "Receita",
        type: FieldTypeEnum.MONEY,
        colSize: 6,
        rules: [{ rule: "required" }],
      },
      {
        key: "empresa_funcionarios",
        name: "Número de Funcionários",
        type: FieldTypeEnum.NUMBER,
        colSize: 6,
        rules: [{ rule: "required" }],
      },
      {
        key: "empresa_prejuizo",
        name: "Empresa com Prejuízo Fiscal?",
        type: FieldTypeEnum.SWITCH,
        colSize: 6,
        rules: [],
      },
      {
        key: "empresa_patente",
        name: "Possui Patente?",
        type: FieldTypeEnum.SWITCH,
        colSize: 6,
        rules: [],
      },
      {
        key: "empresa_patente_justificativa",
        name: "Justificativa da Patente",
        type: FieldTypeEnum.TEXTAREA,
        colSize: 12,
        rules: [],
        showWhen: "empresa_patente",
      },
    ],
    dispendios: [
      {
        key: "dispendio_fonte_financiamento",
        name: "Fonte de Financiamento",
        type: FieldTypeEnum.TEXT,
        colSize: 4,
        rules: [{ rule: "required" }],
      },
      {
        key: "dispendio_recursos_proprios",
        name: "Recursos Próprios",
        type: FieldTypeEnum.TEXT,
        colSize: 4,
        rules: [{ rule: "required" }],
      },
      {
        key: "dispendio_recursos_financiados",
        name: "Recursos Financiados",
        type: FieldTypeEnum.TEXT,
        colSize: 4,
        rules: [{ rule: "required" }],
      },
    ],
    formacao: [
      {
        key: "programa_formacao",
        name: "Possui Programa de Formação?",
        type: FieldTypeEnum.SWITCH,
        colSize: 6,
        rules: [],
      },
      {
        key: "programa_formacao_justificativa",
        name: "Justificativa do Programa de Formação",
        type: FieldTypeEnum.TEXTAREA,
        colSize: 12,
        rules: [],
        showWhen: "programa_formacao",
      },
    ],
  };
}

/**
 * Colunas para a tabela de listagem (LI)
 */
export function getTableColsLI(FieldTypeEnum) {
  return [
    { key: "id", name: "ID", hideInform: true, hideInTable: true },
    { key: "ano_base", name: "Ano Base", type: FieldTypeEnum.NUMBER },
    { key: "qtde_pessoal_total", name: "Pessoal Total", type: FieldTypeEnum.NUMBER },
    { key: "total_empresa", name: "Faturamento Total", type: FieldTypeEnum.MONEY },
    { key: "criado_em", name: "Criado Em", type: FieldTypeEnum.DATETIME, hideInform: true },
    { key: "modificado_em", name: "Modificado Em", type: FieldTypeEnum.DATETIME, hideInForm: true },
  ];
}

/**
 * Colunas para a tabela de listagem (LB)
 */
export function getTableColsLB(FieldTypeEnum) {
  return [
    { key: "id", name: "ID", hideInform: true, hideInTable: true },
    { key: "ano_base", name: "Ano Base", type: FieldTypeEnum.NUMBER },
    { key: "representante_nome", name: "Representante", type: FieldTypeEnum.TEXT },
    { key: "empresa_situacao", name: "Situação", type: FieldTypeEnum.TEXT },
    { key: "criado_em", name: "Criado Em", type: FieldTypeEnum.DATETIME, hideInform: true },
    { key: "modificado_em", name: "Modificado Em", type: FieldTypeEnum.DATETIME, hideInForm: true },
  ];
}
